import Decimal from "decimal.js";

import { CustomerAddress } from "@megaron/crm-contracts";

import { ListedProfileFields } from "./LocationPicker";

export const fetchPlace = async (
  placeId: string,
): Promise<(CustomerAddress & Partial<ListedProfileFields>) | undefined> => {
  const placeService = new google.maps.places.Place({ id: placeId });
  try {
    const details = await placeService.fetchFields({
      fields: ["addressComponents", "location", "types", "displayName", "nationalPhoneNumber", "websiteURI"],
    });
    const placeDetails = details.place;

    if (placeDetails) {
      const addressComponents = placeDetails.addressComponents;
      if (addressComponents) {
        const isEstablishment = placeDetails.types?.includes("establishment");

        const googlePlaceId = isEstablishment ? placeId || null : null;
        const country = addressComponents.find((component) => component.types.includes("country"))?.longText || "";
        const city = addressComponents.find((component) => component.types.includes("locality"))?.longText || "";
        const street = addressComponents.find((component) => component.types.includes("route"))?.longText || "";
        const streetNumber = addressComponents.find((component) => component.types.includes("street_number"))?.longText;
        const postalCode =
          addressComponents.find((component) => component.types.includes("postal_code"))?.longText || "";
        const latitude = placeDetails.location ? new Decimal(placeDetails.location.lat()) : null;
        const longitude = placeDetails.location ? new Decimal(placeDetails.location.lng()) : null;

        const updatedAddress: CustomerAddress = {
          country,
          city,
          street: street + (streetNumber ? ` ${streetNumber}` : ""),
          postalCode,
          latitude,
          longitude,
          googlePlaceId,
        };

        const updatedGoogleFields: Partial<ListedProfileFields> = isEstablishment
          ? {
              listedName: placeDetails.displayName || null,
              listedPhone: placeDetails.nationalPhoneNumber || null,
              listedWebsite: placeDetails.websiteURI || null,
            }
          : {};

        return { ...updatedAddress, ...updatedGoogleFields };
      }
    }
    return undefined;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error occurred while fetching place details:", error);
    return undefined;
  }
};
